﻿export const contextualCore = {
    PositionMenu: (docked, el, menu, owner) => {
        if (docked) {
            menu.style.left = ((el.target.offsetLeft + menu.offsetWidth) >= window.innerWidth) ?
                ((el.target.offsetLeft - menu.offsetWidth) + el.target.offsetWidth) + "px"
                : (el.target.offsetLeft) + "px";

            menu.style.top = ((el.target.offsetTop + menu.offsetHeight) >= window.innerHeight) ?
                (el.target.offsetTop - menu.offsetHeight) + "px"
                : (el.target.offsetHeight + el.target.offsetTop) + "px";
        } else {
            if (el.clientX == null && el.originalEvent != null) {
                el = el.originalEvent;
            }
            menu.style.left = ((el.clientX + menu.offsetWidth) >= window.innerWidth) ?
                ((el.clientX - menu.offsetWidth)) + "px"
                : (el.clientX) + "px";

            menu.style.top = ((el.clientY + menu.offsetHeight) >= $(owner).height()) ?
                (el.clientY - menu.offsetHeight - (owner != null ? $(owner).parent()[0].offsetTop : 0)) + "px"
                : (el.clientY - (owner != null ? $(owner).parent()[0].offsetTop : 0)) + "px";
        }
    },
    CloseMenu: (target, owner) => {
        let openMenuItem = document.querySelector('.contextualMenu:not(.contextualMenuHidden)');
        if (openMenuItem != null) {
            if (target != null) {
                $(target)[0].removeChild(openMenuItem);
            } else {
                document.body.removeChild(openMenuItem);
            }

            owner.contextMenu = null;
            owner.contextMenuFeatureId = null;
            owner.contextMenuLayerId = null;
        }
    },
    CreateEl: (template) => {
        var el = document.createElement('div');
        el.innerHTML = template;
        return el.firstElementChild;
    }
};